function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./purchase-tips-modal.scss";
import template from "./purchase-tips-modal.html";

export var PurchaseTipsModalComponent = {
  template: template,
  bindings: {
    modalTitle: "@",
    description: "@",
    products: "<",
    tipId: "@",
    tipFeedback: "@",
    onShow: "&",
    onClose: "&",
    onGet: "&" },

  controller: /*#__PURE__*/function () {PurchaseTipsModalComponentController.$inject = ["UserService", "LayoutService", "$scope", "$timeout", "iziToast", "gplansConf", "$http", "MiscModel", "ModalsService"];
    function PurchaseTipsModalComponentController(UserService, LayoutService, $scope, $timeout, iziToast, gplansConf, $http, MiscModel, ModalsService) {
      "ngInject";_classCallCheck(this, PurchaseTipsModalComponentController);
      this.LayoutService = LayoutService;
      console.log(this);
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.animateOnShow = false;
      this.iziToast = iziToast;
      this.gplansConf = gplansConf;
      this.UserService = UserService;
      this.MiscModel = MiscModel;
      this.ModalsService = ModalsService;
      this.$http = $http;
      this.state = {
        checkout: true,
        customer: false,
        payment: false };

      this.customer = {
        email: this.UserService.data.email,
        first_name: this.UserService.data.first_name,
        last_name: this.UserService.data.last_name };

      this.paymentMethod = this.UserService.data.payment_method;
      this.amount = -1;
      this.tax = 0.0725 + 0.0225 + 0.0075;
      this.shipping = 10;
      this.quantity = {
        count1: 0,
        count2: 0 };

      this.total = 0;
    }_createClass(PurchaseTipsModalComponentController, [{ key: "onCustomerState", value: function onCustomerState()

      {var _this = this;
        this.MiscModel.get('shippingData').then(function (res) {
          _this.miscData = JSON.parse(res.value);
          _this.customer.email = _this.miscData.customer_data.email;
          _this.customer.cell_phone = _this.miscData.shipping_address.phone;
          _this.customer.first_name = _this.miscData.customer_data.first_name;
          _this.customer.last_name = _this.miscData.customer_data.last_name;
          _this.customer.address1 = _this.miscData.shipping_address.address1;
          _this.customer.city = _this.miscData.shipping_address.city;
          _this.customer.country = _this.miscData.shipping_address.country;
          _this.customer.province = _this.miscData.shipping_address.province;
          _this.customer.zip = _this.miscData.shipping_address.zip;
          _this.calculate();
        });
      } }, { key: "$onInit", value: function $onInit()

      {var _this2 = this;
        this.MiscModel.get('inAppPurchase').then(
        function (misc) {
          _this2.miscAmount = JSON.parse(misc.value);
          _this2.miscLoaded = true;
        },
        function (err) {
          _this2.miscAmount = 0;
          _this2.miscLoaded = false;
        });

        this.productsIds = [];
        for (var i = 0; i < this.products.length; i++) {
          this.productsIds.push(this.products[i].product_id);
        }
        this.variants = {};
        this.productsFromShopify = [];
        this.$http.get(gplansConf.API_URL + '/api/v1/shopify/products/', { params: { 'product': this.productsIds } }).then(function (res) {
          _this2.productsFromShopify = res.data.products;
          for (var _i = 0; _i < res.data.products.length; _i++) {
            _this2.variants[res.data.products[_i].id] = res.data.products[_i];
          }
        });
        if (!this.tipFeedback) {this.$timeout(function () {_this2.getFeedback();}, 5000);}
      } }, { key: "sendFeedback", value: function sendFeedback(

      feedback) {
        this.$http.post(this.gplansConf.API_URL + '/api/v1/tips/feedback/' + this.tipId + '/', { feedback_text: feedback, read: true, viewed: true });
      } }, { key: "sendRead", value: function sendRead()

      {
        this.$http.post(this.gplansConf.API_URL + '/api/v1/tips/read/' + this.tipId + '/');
      } }, { key: "getFeedback", value: function getFeedback()

      {
        var self = this;
        this.iziToast.question({
          class: 'feedback-toast',
          timeout: 2000000,
          backgroundColor: 'white',
          titleColor: 'black',
          close: true,
          overlay: true,
          icon: '',
          id: 'question',
          zindex: 999,
          title: 'Was this tip helpfull?',
          message: '',
          position: 'center',
          transitionIn: 'fadeInUp',
          transitionOut: 'fadeOut',
          buttons: [
          ["<button class=\"feedback-toast__button\"><i class=\"emoji-yes\"><img src=\"data:image/png;base64,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\" alt=\"Yes\" /></i></button>",
          function (instance, toast) {
            self.sendFeedback('Yes');
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            // self.iziToast.show({
            //   title: 'Thank you!',
            //   message: ''});

          }, true],
          ["<button class=\"feedback-toast__button\"><i class=\"emoji-no\"><img src=\"data:image/png;base64,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\" alt=\"No\" /></i></button>",
          function (instance, toast) {
            self.sendFeedback('No');
            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
            // self.iziToast.show({
            //   title: 'We are sorry',
            //   message: '',
            //   backgroundColor: '#843322'});
          }]],

          onClosed: function onClosed() {
            self.sendRead();
          } });

      } }, { key: "onChoose", value: function onChoose(

      productId) {
        this.productVariantId = this.variants[productId].variants[0].id;
        this.amount = parseFloat(this.variants[productId].variants[0].price);
        this.description = this.variants[productId].title + ' - 1';
      } }, { key: "onPaypalSuccess", value: function onPaypalSuccess(

      response) {var _this3 = this;
        var misc;
        if (this.miscLoaded) {
          misc = new this.MiscModel({
            id: 'inAppPurchase',
            value: this.total_amount,
            key: 'inAppPurchase' });

        } else
        {
          misc = new this.MiscModel({
            value: this.total_amount,
            key: 'inAppPurchase' });

        }
        misc.$save().then(function () {
          _this3.miscLoaded = true;
        });
        var params = {
          payment_id: response.paymentID,
          payer_id: response.payerID };

        this.$http.post(this.gplansConf.API_URL + '/api/v1/paypal/payment/execute/',
        params).then(function (result) {
          if (result.data.success) {
            _this3.createOrder();
          } else
          {
            //this.message = "There was a problem processing your payment.";
            _this3.iziToast.show({
              title: 'Sorry!',
              message: 'There was a problem processing your payment.',
              backgroundColor: '#843322' });

          }
        },
        function (err) {
          //this.message = "There was a problem processing your payment.";
          _this3.iziToast.show({
            title: 'Sorry!',
            message: 'There was a problem processing your payment.',
            backgroundColor: '#843322' });

        });
      } }, { key: "getPaypalTokenRequest", value: function getPaypalTokenRequest()

      {
        this.loading = true;
        return {
          method: 'post',
          url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
          json: {
            amount: this.total_amount,
            currency: "USD",
            description: this.description } };


      } }, { key: "createOrder", value: function createOrder()

      {var _this4 = this;
        var data = {
          variants: [{ variant_id: this.productVariantId, quantity: 1 }],
          customer: {
            email: this.customer.email,
            first_name: this.customer.first_name,
            last_name: this.customer.last_name },

          amount: this.total_amount,
          shipping_address: {
            first_name: this.customer.first_name,
            last_name: this.customer.last_name,
            email: this.customer.email,
            phone: this.customer.cell_phone,
            address1: this.customer.address1 + ' ' + this.customer.apartment,
            city: this.customer.city,
            province: this.customer.province,
            country: this.customer.country,
            zip: this.customer.zip },

          protein: true };

        var params = { 'tip_id': this.tipId };
        this.$http.post(gplansConf.API_URL + '/api/v1/shopify/app/order/', data, { params: params }).then(
        function (res) {
          _this4.loading = false;
          if (res.data.success) {
            var self = _this4;
            //this.message = 'Successful purchase';
            _this4.miscAmount = 0;
            _this4.ModalsService.closeAll();
            _this4.iziToast.show({
              title: 'Thank you for the purchase!',
              message: '' });

            _this4.onGet();
            _this4.setState('checkout');
          } else
          {
            //this.message = res.data;
            _this4.iziToast.show({
              title: 'Sorry!',
              message: JSON.stringify(res.data),
              backgroundColor: '#843322' });

            _this4.miscAmount = _this4.total_amount;
          }
        },
        function (err) {
          _this4.loading = false;
          //this.message = err.data;
          _this4.iziToast.show({
            title: 'Sorry!',
            message: JSON.stringify(err.data),
            backgroundColor: '#843322' });

          _this4.miscAmount = _this4.total_amount;
        });

      } }, { key: "buy", value: function buy()

      {var _this5 = this;
        this.loading = true;
        //this.message = '';
        this.$http.post(this.gplansConf.API_URL + '/api/v1/shopify/app/payment/',
        { amount: this.total_amount, description: this.description }).
        then(
        function (res) {
          if (res.data.success) {
            _this5.createOrder();
          }
        },
        function (err) {
          _this5.loading = false;
          //this.message = err.data;
          _this5.iziToast.show({
            title: 'Sorry!',
            message: JSON.stringify(err.data),
            backgroundColor: '#843322' });

        });

      } }, { key: "calculate", value: function calculate()

      {
        if (this.customer.province) {
          this.total_shipping = this.shipping;
          this.total_amount = this.amount;
          if (this.customer.province == 'California') {
            this.total_tax = this.amount * this.tax;
            this.total_tax = parseFloat(this.total_tax.toFixed(2));
          } else
          {
            this.total_tax = 0;
          }
          this.total_amount += this.shipping;
          this.total_amount += this.total_tax;
          this.total_amount = parseFloat(this.total_amount).toFixed(2);
        } else
        {
          this.total_shipping = null;
          this.total_tax = null;
          this.total_amount = null;
        }
      } }, { key: "getChange", value: function getChange()

      {var _this6 = this;
        if (this.address.street_number || this.address.route) {
          if (this.address.country !== 'United States') {
            this.address = '';
            alert('Address should be only from USA!');
            this.customer.city = '';
            this.customer.province = '';
            this.customer.zip = '';
            this.$timeout(function () {
              _this6.customer.place = '';
            }, 10);
          } else
          {
            this.customer.place = "".concat(this.address.street_number, ", ").concat(this.address.route);
            this.customer.city = this.address.locality;
            this.customer.province = this.address.administrative_area_level_1;
            this.customer.zip = this.address.postal_code;
            this.calculate();
          }
        }
      } }, { key: "setState", value: function setState(

      state) {
        //this.message = '';
        for (var key in this.state) {
          if (key === state) {
            this.state[key] = true;
          } else {
            this.state[key] = false;
          }
        }
      } }, { key: "$onChanges", value: function $onChanges()


      {} }, { key: "$postLink", value: function $postLink()

      {var _this7 = this;
        Promise.resolve().
        then(function () {
          _this7.$timeout(function () {
            _this7.animateOnShow = true;
          }, 300);
        }).
        then(function () {
          _this7.$timeout(function () {
            _this7.onShow();
          }, 400);
        });
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        this.onClose();
      } }]);return PurchaseTipsModalComponentController;}() };